import { GuestChartDetail } from "../../../interface/Guest";
import { ChartData, ChartDataSets } from "../../../interface/chartFormatter";
import { color } from "../../../styles/color";

export const getFormattedGuestMonthlyChartData = (
  responseList: GuestChartDetail[] | undefined
) => {
  const labels: string[] = [];
  const datasets: ChartDataSets[] = [];

  const tradeCountData: number[] = [];
  const rentaCountlData: number[] = [];
  const monthlyCountData: number[] = [];
  const totalCountData: number[] = [];

  const tradeRateData: number[] = [];
  const rentaRatelData: number[] = [];
  const monthlyRateData: number[] = [];
  const totalRateData: number[] = [];

  responseList &&
    responseList.map((item: GuestChartDetail) => {
      labels.push(item.period);

      tradeCountData.push(item.count.tradeCount);
      rentaCountlData.push(item.count.rentalCount);
      monthlyCountData.push(item.count.monthlyCount);
      totalCountData.push(item.count.totalCount);

      tradeRateData.push(item.rate.tradeRate);
      rentaRatelData.push(item.rate.rentalRate);
      monthlyRateData.push(item.rate.monthlyRate);
      totalRateData.push(item.rate.totalRate);
    });

  datasets.push(
    {
      label: "전체 등록수",
      data: totalCountData,
      borderColor: "black",
      backgroundColor: "black",
      borderWidth: 2,
      yAxisID: "y",
    },
    {
      label: "매매 등록수",
      data: tradeCountData,
      borderColor: color.trade,
      backgroundColor: color.trade,
      borderWidth: 2,
      yAxisID: "y",
    },

    {
      label: "전세 등록수",
      data: rentaCountlData,
      borderColor: color.rental,
      backgroundColor: color.rental,
      borderWidth: 2,
      yAxisID: "y",
    },
    {
      label: "월세 등록수",
      data: monthlyCountData,
      borderColor: color.monthly,
      backgroundColor: color.monthly,
      borderWidth: 2,
      yAxisID: "y",
    },
    {
      label: "전체 손님확보비율",
      data: totalRateData,
      borderColor: "black",
      backgroundColor: "black",
      borderDash: [5, 5],
      yAxisID: "y1",
    },
    {
      label: "매매 손님확보비율",
      data: tradeRateData,
      borderColor: color.trade,
      backgroundColor: color.trade,
      borderDash: [5, 5],
      yAxisID: "y1",
    },

    {
      label: "전세 손님확보비율",
      data: rentaRatelData,
      borderColor: color.trade,
      backgroundColor: color.trade,
      borderDash: [5, 5],
      yAxisID: "y1",
    },
    {
      label: "월세 손님확보비율",
      data: monthlyRateData,
      borderColor: color.monthly,
      backgroundColor: color.monthly,
      borderDash: [5, 5],
      yAxisID: "y1",
    }
  );

  const chartData: ChartData = { labels, datasets };

  return chartData;
};

export const getFormattedGuestDailyChartData = (
  responseList: Omit<GuestChartDetail, "rate">[] | undefined
) => {
  const labels: string[] = [];
  const datasets: ChartDataSets[] = [];

  const tradeCountData: number[] = [];
  const rentaCountlData: number[] = [];
  const monthlyCountData: number[] = [];
  const totalCountData: number[] = [];

  responseList &&
    responseList.map((item: Omit<GuestChartDetail, "rate">) => {
      labels.push(item.period);

      tradeCountData.push(item.count.tradeCount);
      rentaCountlData.push(item.count.rentalCount);
      monthlyCountData.push(item.count.monthlyCount);
      totalCountData.push(item.count.totalCount);
    });

  datasets.push(
    {
      label: "전체 등록수",
      data: totalCountData,
      borderColor: "black",
      backgroundColor: "black",
      borderWidth: 2,
      yAxisID: "y",
    },
    {
      label: "매매 등록수",
      data: tradeCountData,
      borderColor: color.trade,
      backgroundColor: color.trade,
      borderWidth: 2,
      yAxisID: "y",
    },

    {
      label: "전세 등록수",
      data: rentaCountlData,
      borderColor: color.rental,
      backgroundColor: color.rental,
      borderWidth: 2,
      yAxisID: "y",
    },
    {
      label: "월세 등록수",
      data: monthlyCountData,
      borderColor: color.monthly,
      backgroundColor: color.monthly,
      borderWidth: 2,
      yAxisID: "y",
    }
  );

  const chartData: ChartData = { labels, datasets };

  return chartData;
};
